<template>
  <div
    data-component-group="billing-panel"
    data-component="conflicts"
    class="elevation-1"
  >
    <slot name="beforeForm" />

    <div class="error-message">
      <v-icon>report_problem</v-icon>

      <span class="message">
        {{ conflict.error_message }}
      </span>
    </div>

    <div class="conflict-item">
      <AmountLabel
        v-for="{ field, value } in conflict.diff"
        :key="field"
        :label="getDiffLabel(field)"
        :value="value"
      />
    </div>
  </div>
</template>

<script>
  import AmountLabel from '../../labels/Amount';
  import { isStr, isArr, isObj, capitalize } from '../../../utils';

  export default {
    components: {
      AmountLabel,
    },
    props: {
      conflict: {
        type: Object,
        required: true,
        validator(value) {
          return isObj(value) && isStr(value.error_message) && isArr(value.diff);
        },
      },
    },
    methods: {
      getDiffLabel(field) {
        return field
          .split('_')
          .map((word) => capitalize(word))
          .join(' ');
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='billing-panel'][data-component='conflicts'] {
  padding: $spacing-md;
  margin-top: -20px;
  border-radius: $border-radius;
  background-color: map.get($colors, shades, 'white');

  .error-message {
    font-size: $text-size-lg;
    color: map.get($colors, primary);
    margin: 0 0 20px 0;

    .v-icon {
      color: map.get($colors, primary);
    }
  }

  .conflict-item {
    [data-component='amount'] {
      padding: 0 32px 10px 32px;
      margin: 0 -32px 10px -32px;
      border-bottom: 1px solid map.get($colors, grey, lighten-2);

      .item-label {
        font-weight: bold;
        color: map.get($colors, shades, 'black');
      }
    }

    &:last-child {
      [data-component='amount'] {
        padding-bottom: 0;
        margin-bottom: 0;
        border: 0;
      }
    }
  }
}
</style>
